const fontSizeKey = 'fontsize-'
const colorKey = 'color-'
const backgroundColorKey = 'bgcolor-'
export const getKey = (styles: any, key: string): string =>
  styles.filter(value => value.startsWith(key)).first()
export const getKeyValue = (key: string, style: string): string | undefined =>
  style ? style.replace(key, '') : undefined

const inlineStyleFn = (
  styles: any,
):
  | {
      element: 'span'
      style: {
        backgroundColor?: string
        color?: string
        fontSize?: string
      }
    }
  | null
  | undefined => {
  const fontSize = getKey(styles, fontSizeKey)
  const color = getKey(styles, colorKey)
  const backgroundColor = getKey(styles, backgroundColorKey)

  if (fontSize || color || backgroundColor) {
    const style: {
      backgroundColor?: string
      color?: string
      fontSize?: string
    } = {}
    if (fontSize) style.fontSize = getKeyValue(fontSizeKey, fontSize)
    if (color) style.color = getKeyValue(colorKey, color)
    if (backgroundColor)
      style.backgroundColor = getKeyValue(backgroundColorKey, backgroundColor)
    return {
      element: 'span',
      style,
    }
  }

  return null
}

export default inlineStyleFn
